import { DataBrokerAction } from "./DataBrokers.model";
import { IPrivacyFootprintServiceStatus } from "./PrivacyFootprint.model";

export class RemediationServiceDetails {
    name: string;
    primaryMethod: DataBrokerAction;
    thumbnail: {
        katastif_id?: string,
        url: string
    };
    methodText: string;
    title: string;
    descriptionShown: string;
    disclaimer: string;
    alert?: any;
    primaryMethodData: RemediationMethodDetails;
}

export class RemediationMethodDetails {
    type: RemediationPrimaryMethod | DataBrokerAction;
    primaryMethodData?: RemediationPrimaryMethod;
    primary_action: {
        type: RemediationPrimaryMethod | DataBrokerAction;
        url: string;
        email_address?: string;
        value?: string;
    };
    method_text?: string;
    title?: string;
    description_shown?: string;
    service_domain?: string;
    actions?: RemediationActionDetails[];
}

export class RemediationActionDetails {
    type: RemediationActionType;
    text: string;
    url: string;
    text_shown?: string;
}

export enum RemediationPrimaryMethod {
    privacySettings = "privacy_settings",
    personalInformation = "personal_information",
    email = "email",
    link = "link",
    url = "url",
    request = "request",
}

export enum RemediationActionType {
    REMOVE_PERSONAL_INFO = 'remove_personal_info',
    MANAGE_MENTIONS = 'manage_mentions',
    MANAGE_SEARCH = 'manage_search',
    MANAGE_PERSONALISATION = 'manage_personalisation',
    MANAGE_COOKIES = 'manage_cookies',
    DATA_DOWNLOAD_EOS = 'data_download_eos',
    MANAGE_SERVICE_INFO = 'manage_service_info',
    MANAGE_SETTINGS_PRIVACY = 'manage_settings_privacy',
    MANAGE_SETTINGS_ADS = 'manage_settings_ads',
    DATA_USAGE = 'data_usage',
    DATA_THIRD_PARTY = 'data_third_party',
    PREFERENCES_ADS = 'preferences_ads',
    MANAGE_SERVICES = 'manage_services',
    DATA_COLLECTED = 'data_collected',
    PREFERENCES_JOB_SEEKING = 'preferences_job_seeking',
    DATA_DOWNLOAD = 'data_download',
    DO_NOT_SELL = 'do_not_sell',
    MANAGE_BROWSING_HISTORY = 'manage_browsing_history',
    MANAGE_ADS_PREFERENCES = 'manage_ads_preferences',
    DATA_REQUEST = 'data_request',
    DATA_DOWNLOAD_ARCHIVE = 'data_download_archive',
    OTHER_DISCOVERABILITY_AND_CONTACTS = 'other_discoverability_and_contacts',
    MANAGE_ADD_PREFERENCES = 'manage_add_preferences',
    OTHER_DISABLE_ACTIVITY_TRACKING = 'other_disable_activity_tracking',
    DATA_DO_NOT_SHARE = 'data_do_not_share',
    MANAGE_LOCATION_INFO = 'manage_location_info',
    FILTER_PUBLIC_POSTS = 'filter_public_posts',
    CHECK_YOUR_SECURITY_SETTINGS = 'check_your_security_settings'
}
export interface IUserRemediationsTypes {
    [key: string]: IUserRemediationTypesData;
}

export interface IUserRemediationTypesData {
    reviewed_at: Date;
    status?: IPrivacyFootprintServiceStatus;
    new?: boolean;
    yearsPassed?: number;
    daysPassed?: number;
    show?: boolean;
}